import {usePlaneduHttpService} from "../service/planedu.http.service";
import {FinancialDocumentTypeTaxEntity} from "../entity/financial-document-type-tax.entity";

export function useFinancialDocumentTypeTaxRepository() {
  const httpService = usePlaneduHttpService<FinancialDocumentTypeTaxEntity>('financial-document-type-tax');
  return {
    ...httpService,
  }
}